import React from "react";

const guidelines = [
  {
    title: "Alcohol & considerate conduct",
    points: [
      "Alcohol is not sold at the campsite. If you choose to bring your own, carry the required one-day permit from a licensed liquor shop.",
      "Drink responsibly and respect other guests. Guests whose behaviour disturbs or endangers others may be asked to leave.",
    ],
  },
  {
    title: "Activities & campsite property",
    points: [
      "Boating and kayaking are optional activities and are not included in the camping package.",
      "Changes to your tent arrangement may not be possible after your tent has been assigned and set up. Speak with the campsite coordinator about your stay.",
      "Guests are responsible for damage to campsite property caused by them or their group. Repair or replacement charges may apply.",
    ],
  },
  {
    title: "Health & personal safety",
    points: [
      "Bring any personal medication and essentials you may need during your camping stay.",
      "Camping activities involve inherent risks. Follow staff guidance and participate at your own discretion. The campsite is not responsible for injuries or lost personal belongings.",
      "The campsite cannot guarantee against loss, theft, damage, or service disruptions caused by weather or government action.",
    ],
  },
  {
    title: "What to wear and bring",
    points: [
      "At check-in, confirm your selected stay type and ask the coordinator about available bedsheets and blankets. Pillows are not provided in tents.",
      "Blankets may be lightweight. Bring an extra blanket and warm layers—such as a jacket, shawl, gloves, or socks—especially during winter.",
      "Bring a power bank, as access to shared charging points may be limited.",
      "Tissues and mosquito repellent are not provided, so please pack your own.",
    ],
  },
  {
    title: "Meals & drinking water",
    points: [
      "BBQ and snacks are served in limited quantities and may not be available once they run out.",
      "Follow the meal timings so food can be served fresh. Ask the coordinator if you need help with the schedule.",
      "Shared mineral-water jars are available. Individual bottled water is not included in the camping package.",
    ],
  },
  {
    title: "Arrival & payment",
    points: [
      "Arrive at the confirmed campsite on time and check in with the campsite coordinator.",
      "Carry sufficient cash to help make check-in smooth, especially where digital payment may not be available.",
      "Please complete any outstanding camping payment with the campsite team on arrival, before check-in is completed.",
    ],
  },
];

const CampAdvisory = () => (
  <main className="mx-auto max-w-5xl rounded-3xl bg-gradient-to-br from-sky-50 via-blue-50 to-slate-50 px-4 py-8 text-stone-800 sm:px-6 sm:py-12 lg:px-8">
    <header className="mb-8 rounded-2xl bg-gradient-to-r from-blue-950 to-blue-800 px-6 py-8 text-white shadow-md sm:px-9 sm:py-10">
      <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-sky-200">
        Before you arrive
      </p>
      <h1 className="text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
        Camp Advisory
      </h1>
      <p className="mt-3 max-w-2xl text-sm leading-6 text-blue-50 sm:text-base">
        Planning a Pawna Lake camping stay? Review these practical guidelines
        before you arrive to help make check-in smooth and your outdoor
        experience comfortable and enjoyable.
      </p>
    </header>

    <div className="grid gap-4 sm:grid-cols-2">
      {guidelines.map((guideline, index) => (
        <section
          key={guideline.title}
          className="rounded-2xl border border-sky-200 bg-white/90 p-5 shadow-sm sm:p-6"
        >
          <div className="mb-4 flex items-center gap-3">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-blue-950">
              {String(index + 1).padStart(2, "0")}
            </span>
            <h2 className="text-base font-semibold leading-6 text-slate-900 sm:text-lg">
              {guideline.title}
            </h2>
          </div>
          <ul className="space-y-3">
            {guideline.points.map((point) => (
              <li
                key={point}
                className="flex gap-3 text-sm leading-6 text-slate-700 sm:text-base"
              >
                <span
                  aria-hidden="true"
                  className="mt-[0.65rem] h-1.5 w-1.5 shrink-0 rounded-full bg-blue-700"
                />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>

    <p className="mt-6 rounded-xl border border-sky-200 bg-sky-100/70 px-5 py-4 text-sm leading-6 text-blue-950 sm:text-base">
      By joining the camping experience, guests agree to follow these
      guidelines and help maintain a safe, peaceful, and respectful environment
      for everyone.
    </p>
  </main>
);

export default CampAdvisory;
